import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, IconButton, Snackbar } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import cx from 'clsx';
import { useState } from 'react';
var hiddenStyle = { display: 'none' };
export function CopyLinkButton() {
    var _a = useState(false), snackbar = _a[0], setSnackbar = _a[1];
    var onCopied = function () {
        var _a;
        var targetURL = window.location.href.substr(0, window.location.href.indexOf('?') > 0
            ? window.location.href.indexOf('?')
            : window.location.href.length);
        if (navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) {
            navigator.clipboard.writeText(targetURL).then(function () {
                return setSnackbar(true);
            });
        }
        else {
            var copyField = document.createElement('textarea');
            copyField.value = targetURL;
            copyField.style.userSelect = 'auto';
            document.body.appendChild(copyField);
            copyField.select();
            document.execCommand('copy');
            (_a = copyField.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(copyField);
            return setSnackbar(true);
        }
    };
    var handleClose = function () {
        setSnackbar(false);
    };
    var action = (_jsx(IconButton, { size: "small", "aria-label": "close", color: "inherit", onClick: handleClose, className: cx('faq-snackbar-button-copy-link'), children: _jsx(Close, { fontSize: "small", className: cx('faq-snackbar-button-icon-copy-link') }) }));
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: cx('faq-button-copy-link-wrapper'), children: _jsx(Button, { style: hiddenStyle, className: cx('faq-button', 'faq-button-copy-link'), onClick: onCopied, variant: "contained", color: "secondary", size: 'small', children: "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC\u3059\u308B" }) }), _jsx(Snackbar, { open: snackbar, autoHideDuration: 6000, onClose: handleClose, message: "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F", action: action, className: cx('faq-snackbar-copy-link') })] }));
}
//# sourceMappingURL=CopyLinkButton.js.map